module.exports = __webpack_public_path__ + "static/GKF1-d61feb1adf44c46fef888aacb4423ad2.jpg";